const types = {
	//Get Template name
	GET_SAMPLE_LIST_START: "GET_SAMPLE_LIST_START",
	GET_SAMPLE_LIST_SUCCESS: "GET_SAMPLE_LIST_SUCCESS",
	GET_SAMPLE_LIST_ERROR: "GET_SAMPLE_LIST_ERROR",
	GET_SAMPLE_LIST_RESET: "GET_SAMPLE_LIST_RESET",

	//Create Template name
	CREATE_SAMPLE_LIST_START: "CREATE_SAMPLE_LIST_START",
	CREATE_SAMPLE_LIST_SUCCESS: "CREATE_SAMPLE_LIST_SUCCESS",
	CREATE_SAMPLE_LIST_ERROR: "CREATE_SAMPLE_LIST_ERROR",
	CREATE_SAMPLE_LIST_RESET: "CREATE_SAMPLE_LIST_RESET",

	//delete Template name
	DELETE_SAMPLE_LIST_START: "DELETE_SAMPLE_LIST_START",
	DELETE_SAMPLE_LIST_SUCCESS: "DELETE_SAMPLE_LIST_SUCCESS",
	DELETE_SAMPLE_LIST_ERROR: "DELETE_SAMPLE_LIST_ERROR",
	DELETE_SAMPLE_LIST_RESET: "DELETE_SAMPLE_LIST_RESET",

	//update Template name
	UPDATE_SAMPLE_LIST_START: "UPDATE_SAMPLE_LIST_START",
	UPDATE_SAMPLE_LIST_SUCCESS: "UPDATE_SAMPLE_LIST_SUCCESS",
	UPDATE_SAMPLE_LIST_ERROR: "UPDATE_SAMPLE_LIST_ERROR",
	UPDATE_SAMPLE_LIST_RESET: "UPDATE_SAMPLE_LIST_RESET",

	//single item  name
	SINGLE_SAMPLE_LIST_START: "SINGLE_SAMPLE_LIST_START",
	SINGLE_SAMPLE_LIST_SUCCESS: "SINGLE_SAMPLE_LIST_SUCCESS",
	SINGLE_SAMPLE_LIST_ERROR: "SINGLE_SAMPLE_LIST_ERROR",
	SINGLE_SAMPLE_LIST_RESET: "SINGLE_SAMPLE_LIST_RESET",
};

export default types;
